var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.changeValue)?_c('v-icon',{class:_vm.changeValue > 0 ? 'change-increase' : 'change-decrease',attrs:{"name":_vm.changeValue > 0 ? 'caret-up' : 'caret-down'}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }